import React, { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { FiMenu, FiX } from 'react-icons/fi';
import '../../styles/Landing.css';

const PublicNavbar = () => {
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
    const location = useLocation();
    const navigate = useNavigate();

    const handleNavClick = (hash) => {
        setMobileMenuOpen(false);
        if (location.pathname !== '/') {
            navigate(`/${hash}`);
        } else {
            const element = document.querySelector(hash);
            if (element) {
                element.scrollIntoView({ behavior: 'smooth' });
            }
        }
    };

    return (
        <nav
            className="landing-nav"
            style={{
                position: location.pathname === '/pricing' ? 'relative' : 'absolute',
                paddingTop: location.pathname === '/pricing' ? '24px' : '1.5rem',
                paddingBottom: location.pathname === '/pricing' ? '24px' : '1.5rem',
                borderBottom: location.pathname === '/pricing' ? '1px solid #f1f5f9' : 'none',
                backgroundColor: location.pathname === '/pricing' ? '#ffffff' : 'transparent'
            }}
        >
            <Link to="/" className="logo" style={{ textDecoration: 'none' }}>IdevPlus</Link>

            <button
                className="nav-hamburger"
                onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
                aria-label="Menú"
            >
                {mobileMenuOpen ? <FiX size={24} /> : <FiMenu size={24} />}
            </button>

            <div className={`nav-menu ${mobileMenuOpen ? 'nav-menu-open' : ''}`}>
                <div className="nav-links-center">
                    <a href="#quienes-somos" className="nav-link" onClick={(e) => { e.preventDefault(); handleNavClick('#quienes-somos'); }}>¿Quiénes somos?</a>
                    <a href="#productos" className="nav-link" onClick={(e) => { e.preventDefault(); handleNavClick('#productos'); }}>Productos</a>
                    <Link to="/pricing" className="nav-link" onClick={() => setMobileMenuOpen(false)}>Precios</Link>
                    <Link to="/contacto" className="nav-link" onClick={() => setMobileMenuOpen(false)}>Contacto</Link>
                </div>
                <div className="nav-auth">
                    <Link to="/login" className="btn-login" onClick={() => setMobileMenuOpen(false)}>Iniciar Sesión</Link>
                    <Link to="/register" className="btn-register" onClick={() => setMobileMenuOpen(false)}>Prueba Gratis</Link>
                </div>
            </div>
        </nav>
    );
};

export default PublicNavbar;
